import { Icon, IconProps } from "../Icon";

const Add = (props: IconProps) => (
  <Icon {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M17 15V7H15V15H7V17H15V25H17V17H25V15H17Z" fill="currentColor" />
  </Icon>
);

export default Add;
